import { Theme } from 'framework/theme/types';
import { ThemedColor } from '../types';
import { getDarkColor } from './getDarkColor';
import { getLightColor } from './getLightColor';

export function getThemedColor(color: ThemedColor, theme: Theme): string {
	if (theme == Theme.Dark) {
		return color.dark ?? getDarkColor(color.light);
	}

	return color.light ?? getLightColor(color.dark);
}
